/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBadge from "components/SoftBadge";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import dayjs from "dayjs";
import { getColor } from "utils/colors";
import { formatMoneyPunto, makeNiceText } from "utils/formatters";

const getRows = (data, handleAction) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        type: (
          <SoftBox
            display="flex"
            alignItems="center"
            sx={{
              cursor: "pointer",
            }}
            data={
              <Icon
                sx={{
                  verticalAlign: "middle",
                  cursor: "pointer",
                  color: getColor("gobPrimary"),
                }}
                fontSize="lg"
              >
                report_gmailerrorred
              </Icon>
            }
            onClick={(e) => handleAction(item)}
          >
            <SoftBox pl={3} mr={2}>
              <Tooltip title={"Infracción"} placement="top">
                <Icon
                  sx={{
                    verticalAlign: "middle",
                    cursor: "pointer",
                    color: getColor("gobPrimary"),
                  }}
                  fontSize="lg"
                >
                  report_gmailerrorred
                </Icon>
              </Tooltip>
            </SoftBox>
          </SoftBox>
        ),
        id: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={`${item?.id}`}
            onClick={(e) => handleAction(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="bold"
            >
              {`${item?.id}`}
            </SoftTypography>
          </SoftBox>
        ),
        infractor: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={
              item?.usuario?.apellido
                ? makeNiceText(item?.usuario?.apellido + " " + item?.usuario?.nombre, "nombre")
                : makeNiceText(item?.apellido + " " + item?.nombre, "nombre")
            }
            onClick={(e) => handleAction(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.usuario?.apellido
                ? makeNiceText(item?.usuario?.apellido + " " + item?.usuario?.nombre, "nombre")
                : makeNiceText(item?.apellido + " " + item?.nombre, "nombre")}
            </SoftTypography>
          </SoftBox>
        ),
        categoria: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={`${item?.categoria}`}
            onClick={(e) => handleAction(item)}
          >
            <SoftBadge
              color={item.categoria === "Bosque" ? "primary" : "gobSecondary"}
              badgeContent={
                <SoftBox display="flex" alignItems="center">
                  <SoftTypography
                    variant="caption"
                    color="white"
                  >
                    {item.categoria}&nbsp;
                    <Icon sx={{
                      verticalAlign: "middle",
                    }}>
                      {item.categoria === "Bosque" ? "park" : "pets"}
                    </Icon>
                  </SoftTypography>
                </SoftBox>
              }
            />
          </SoftBox>
        ),
        fecha: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={dayjs(item?.fecha).format("DD/MM/YYYY") || ""}
            onClick={(e) => handleAction(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {dayjs(item?.fecha).format("DD/MM/YYYY") || ""}
            </SoftTypography>
          </SoftBox>
        ),
        dni: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            data={formatMoneyPunto(item?.usuario?.dni || item?.dni)}
            onClick={(e) => handleAction(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {formatMoneyPunto(item?.usuario?.dni || item?.dni)}
            </SoftTypography>
          </SoftBox>
        ),
        nroExpediente: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleAction(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.nroExpediente}
            </SoftTypography>
          </SoftBox>
        ),
        nroResolucion: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleAction(item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.nroResolucion}
            </SoftTypography>
          </SoftBox>
        ),
        accion: (
          <SoftBox
            mr={2}
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleAction(item)}
          >
            <Tooltip title="Ver detalles" placement="top">
              <Icon
                sx={{ color: getColor("gobSecondary"), cursor: "pointer", mx: 0.5 }}
                fontSize="small"
                onClick={(e) => handleAction(item)}
              >
                arrow_forward
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "type", desc: " ", align: "left", width: "1%", noOrder: true },
  { name: "id", desc: "ID", width: "1%", align: "left" },
  { name: "infractor", desc: "Infractor", align: "left", orderField: "dni" },
  { name: "categoria", desc: "Categoría", align: "left" },
  { name: "fecha", desc: "Fecha", align: "left" },
  { name: "dni", desc: "DNI", align: "left" },
  { name: "nroExpediente", desc: "Nº de Expediente", align: "left" },
  { name: "nroResolucion", desc: "Nº de Resolución", align: "left" },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

export default { columns, getRows };
